import {BGColor} from './colors';
import {PageUser} from './pages';
import {Diff} from './revisions';

import {OrderDirection} from '.';

export type GridCellData =
    | string
    | boolean
    | string[]
    | GridTicketData
    | GridUserData
    | GridEnumTicketField
    | GridUserData[]
    | Diff;

export type GridUserData = PageUser | UnresolvedPageUser;

interface UnresolvedPageUser {
    username: string;
}

export interface GridTicketData {
    key: string;
    resolved: boolean;
}

// status, priority and type
export interface GridEnumTicketField {
    key: string;
    display: string;
}

export interface GridRow {
    id: string;
    color: BGColor | null;
    pinned: boolean;
    row: GridCellData[];
}

export interface GridSort {
    slug: string;
    direction: OrderDirection;
    title?: string;
}

export type GridDefaultSort = Record<string, OrderDirection>;

export interface GridStructure {
    default_sort?: GridSort[];
    columns: GridField[];
}

export type GridFieldWidthUnits = '%' | 'px';

export interface GridField {
    slug: string;
    title: string;
    type: GridFieldType;
    required: boolean;
    description?: string;
    width?: number | null;
    width_units?: GridFieldWidthUnits;
    // TODO ask backend again about the format of the pinned
    pinned?: 'left' | 'right' | null;
    color: BGColor | null;
    multiple?: boolean;
    format?: GridStringFieldFormat;
    ticket_field?: GridTicketFieldType;
    select_options?: string[];
    mark_rows?: boolean;
}

export enum GridFieldType {
    String = 'string',
    Number = 'number',
    Date = 'date',
    Select = 'select',
    Staff = 'staff',
    Checkbox = 'checkbox',
    Ticket = 'ticket',
    TicketField = 'ticket_field',
}

export enum ColumnActionImportGridPreview {
    NewColumn = 'new_column',
    ExistingColumn = 'existing_column',
    Skip = 'skip',
    Error = 'error',
}

export enum ColumnImportListType {
    ColumnTitle = 'column_title',
    ColumnType = 'column_type',
    ColumnSlug = 'column_slug',
}

export enum ImportGridPreview {
    GridColumns = 'grid_columns',
    ColumnTitles = 'column_titles',
    Rows = 'rows',
    NumColoms = 'num_coloms',
    NumRows = 'num_rows',
}

export interface UpdateColumnParams {
    column: string;
    errorCode?: string;
}

export interface UpdateDropdownItemsParams {
    dropdownItemsCurrent: GridField[];
    index: number;
    isDelete?: boolean;
    currentColumn?: Record<string, number | GridField | undefined>;
}

export interface UpdateDataSelectParams {
    rows?: Record<string, React.JSX.Element>[];
}

export interface ColumnImportList {
    action?: ColumnActionImportGridPreview;
    column_title?: string;
    column_type?: string;
    column_slug?: string;
}

export interface UpdateColumnImportListParams {
    columnImportList: ColumnImportList[];
    index: number;
    action: ColumnActionImportGridPreview;
    columnTitle?: string;
    columnType?: string;
    columnSlug?: string;
}

export enum GridStringFieldFormat {
    Plain = 'plain',
    Yfm = 'yfm',
    WikiMarkup = 'wom',
}

export enum GridTicketFieldType {
    Assignee = 'assignee',
    Reporter = 'reporter',
    Status = 'status',
    Priority = 'priority',
    Type = 'type',
    Subject = 'subject',
    UpdatedAt = 'updated_at',
    CreatedAt = 'created_at',
    OriginalEstimation = 'original_estimation',
    FixVersions = 'fixversions',
    Components = 'components',
    StoryPoints = 'storypoints',
    Deadline = 'deadline',
    Description = 'description',
    End = 'end',
    Estimation = 'estimation',
    Followers = 'followers',
    LastCommentUpdatedAt = 'last_comment_updated_at',
    Parent = 'parent',
    PendingReplyFrom = 'pending_reply_from',
    Project = 'project',
    Queue = 'queue',
    Resolution = 'resolution',
    ResolvedAt = 'resolved_at',
    Sprint = 'sprint',
    Start = 'start',
    StatusStartTime = 'status_start_time',
    StatusType = 'status_type',
    Tags = 'tags',
    Votes = 'votes',
}

export interface GridChange {
    editors: PageUser[];
    last_revision: string;
}

export interface GridChangePoint {
    gridId: string;
    revision: string;
}

export enum GridImportError {
    GridImportFailure = 'GRID_IMPORT_FAILURE',
    GridImportValidationError = 'GRID_IMPORT_VALIDATION_ERROR',
    RowValidationError = 'ROW_VALIDATION_ERROR',
    TicketRelatedFieldConflict = 'TICKET_RELATED_FIELD_CONFLICT',
    RowAddConflict = 'ROW_ADD_CONFLICT',
    ValidationError = 'VALIDATION_ERROR',
    GridUnknownColumnError = 'GRID_UNKNOWN_COLUMN_ERROR',
    NotFound = 'NOT_FOUND',
    UnknownColumns = 'unknown_columns',
}
